import React, { useId } from 'react';
import { cn } from '../../lib/utils';

interface AppIconProps {
  /** Chakra のスペーシング単位（1 = 0.25rem）。従来の呼び出しと互換 */
  size?: number;
  className?: string;
}

/**
 * LogMe のシンボルマーク（三日月 + 歯車）1色版。
 *
 * 色は currentColor に追従する。既定は #16224E で、置かれる面が暗い場合は
 * 呼び出し側で text-* を渡して上書きする（cn / tailwind-merge で差し替わる）。
 * フルカラー版（濃茶タイル + 金の月 + 橙の歯車）は public/icons/icon.svg。
 */
export const AppIcon: React.FC<AppIconProps> = ({ size = 12, className }) => {
  // useId の戻り値は ":r0:" 等、CSS/URL 参照に使えない文字を含むため除去する
  const maskId = `logme-mark-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  const dimension = `${size * 0.25}rem`;

  return (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center text-[#16224E]', className)}
      style={{ width: dimension, height: dimension }}
    >
      <svg
        viewBox="0 0 512 512"
        width="100%"
        height="100%"
        fill="none"
        role="img"
        aria-label="LogMe"
      >
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="512" height="512">
          <rect width="512" height="512" fill="#000" />
          {/* 三日月 */}
          <circle cx="176" cy="171" r="128" fill="#fff" />
          <circle cx="224" cy="125" r="108" fill="#000" />
          {/* 月と歯車の間の隙間（歯車はこの後に描いて塗り戻す） */}
          <circle cx="352" cy="357" r="106" fill="#000" />
          {/* 歯車 */}
          <g fill="#fff">
            <rect x="330" y="253" width="44" height="208" rx="12" />
            <rect x="330" y="253" width="44" height="208" rx="12" transform="rotate(60 352 357)" />
            <rect x="330" y="253" width="44" height="208" rx="12" transform="rotate(120 352 357)" />
            <circle cx="352" cy="357" r="74" />
          </g>
          {/* 歯車の中心穴 */}
          <circle cx="352" cy="357" r="34" fill="#000" />
        </mask>
        <rect width="512" height="512" fill="currentColor" mask={`url(#${maskId})`} />
      </svg>
    </span>
  );
};

export default AppIcon;
